import { render, staticRenderFns } from "./IconTriangleDown.vue?vue&type=template&id=6b004bf0&"
import script from "./IconTriangleDown.vue?vue&type=script&lang=js&"
export * from "./IconTriangleDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports